// extracted by mini-css-extract-plugin
export default {"search":"GenericTable_search__YVKyl"};